// extracted by mini-css-extract-plugin
export default {"tooltip":"T0RZAh","tooltipArrow":"Yf6o7w","rtl":"Gegs3C","centerAligned":"V1a_ZY","singleFileBehavior":"fyLkKU","tooltipContainer":"zxTdi2","tooltipTrigger":"BBAbHo"};